var customerService={};export default customerService;